/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.grid\":\"Grid of squares\"}");